import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './timeline-vertical.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
import * as _ from 'lodash';
var TimelineVertical = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineVertical, _super);
    function TimelineVertical(element) {
        return _super.call(this, element) || this;
    }
    TimelineVertical.prototype.init = function () {
        var _this = this;
        if (this.element.classList.contains('timeline-vertical__json')) {
            //////////////////////////////////////////
            //////////////////////////////////////////
            ////	JSON TIMELINE
            //////////////////////////////////////////
            //////////////////////////////////////////
            if (jsonTimeline) {
                this.filterJson = jsonTimeline;
            }
            this.filterYearSliderContainer = this.element.querySelector('.js-filter-years');
            this.filterContentSliderContainer = this.element.querySelector('.js-filter-articles');
            this.filterButtonReset = document.querySelector('.js-reset-timeline-v2');
            this.createCorrectJson(this.filterJson);
        }
        else {
            //////////////////////////////////////////
            //////////////////////////////////////////
            ////	NORMAL TIMELINE
            //////////////////////////////////////////
            //////////////////////////////////////////
            this.yearsSlider = new Swiper(this.element.querySelector('.timeline-vertical__years'), {
                slidesPerView: 20,
                direction: 'vertical',
                centeredSlides: true,
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: false,
            });
            this.contentSlider = new Swiper(this.element.querySelector('.timeline-vertical__content'), {
                slidesPerView: 'auto',
                direction: 'vertical',
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: true,
                mousewheel: {
                    invert: false,
                },
            });
            this.yearsSlider.on('slideChange', function () {
                console.log('Slide Change Normal');
                var yearsSliderContainer = _this.element.querySelector('.timeline-vertical__years');
                if (_this.yearsSlider.realIndex === 0) {
                    yearsSliderContainer.classList.remove('timeline-vertical__years--activated');
                }
                else {
                    yearsSliderContainer.classList.add('timeline-vertical__years--activated');
                }
                _this.contentSlider.slideTo(_this.yearsSlider.realIndex);
            });
            this.contentSlider.on('slideChange', function () {
                var yearsSliderContainer = _this.element.querySelector('.timeline-vertical__years');
                if (_this.yearsSlider.realIndex === 0) {
                    yearsSliderContainer.classList.remove('timeline-vertical__years--activated');
                }
                else {
                    yearsSliderContainer.classList.add('timeline-vertical__years--activated');
                }
                _this.yearsSlider.slideTo(_this.contentSlider.realIndex);
            });
            this.yearsSlides = Array.from(this.element.querySelectorAll('.timeline-vertical__years .swiper-slide'));
            if (document.querySelector('.js-reset-timeline')) {
                this.buttonReset = document.querySelector('.js-reset-timeline');
            }
        }
    };
    TimelineVertical.prototype.bindEvents = function () {
        var _this = this;
        if (this.yearsSlider) {
            this.yearsSlides.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var container = element.querySelector('.timeline-vertical__years--year');
                var getIndex = container.getAttribute('data-index');
                _this.contentSlider.slideTo(getIndex - 1);
                _this.yearsSlider.slideTo(getIndex - 1);
            }); });
        }
        // Reset button for Timeline V1
        if (this.buttonReset) {
            this.buttonReset.addEventListener('click', function (event) {
                event.preventDefault();
                _this.yearsSlider.slideTo(0);
            });
        }
        // Reset button for JSON Timeline
        if (this.filterButtonReset) {
            this.filterButtonReset.addEventListener('click', function (event) {
                var filterYearSlider = _this.element.querySelector('.timeline-vertical__years--filter');
                filterYearSlider.classList.remove('timeline-vertical__years--activated');
                _this.createCorrectJson(_this.filterJson);
            });
        }
        // check if it has the select option
        if (this.filterOption) {
            this.filterOption.addEventListener('change', function (event) {
                var element = undefined;
                if (event.target) {
                    element = event.target;
                }
            });
        }
    };
    TimelineVertical.prototype.createCorrectJson = function (json) {
        var _this = this;
        var htmlSelect = "";
        var indexSelect = 0;
        // create select box
        json.map(function (option) {
            htmlSelect += "<option value=\"" + indexSelect + "\">" + option.name + "</option>";
            indexSelect = indexSelect + 1;
        });
        this.filterOption = this.element.querySelector('.js-filter-timeline');
        this.filterOption.innerHTML = htmlSelect;
        this.filterOption.addEventListener('change', function (event) {
            var element = undefined;
            if (event.target) {
                element = event.target;
            }
            if (element.value === 'all') {
                _this.createYearsArticles(_this.filterJson);
            }
            else {
                _this.createYearsArticles(_this.filterJson, element.value);
            }
        });
        this.createYearsArticles(this.filterJson, 0);
    };
    TimelineVertical.prototype.createYearsArticles = function (json, option) {
        var _this = this;
        if (option === void 0) { option = undefined; }
        var htmlYears = "";
        var htmlArticles = "";
        var index = 0;
        if (this.filterContentSlider) {
            this.filterContentSlider.destroy();
        }
        if (this.filterYearSlider) {
            this.filterYearSlider.destroy();
        }
        // create years & content
        if (option === undefined) {
            var lodashArray_1 = _(json).flatMap('items').groupBy('name').value();
            var keys = Object.keys(lodashArray_1);
            var keysOrdered = _.orderBy(keys, function (o) {
                return o;
            }, ['desc']);
            keysOrdered.map(function (year) {
                var headingShown = false;
                var getArticles = lodashArray_1[year];
                index = index + 1;
                htmlYears += "<div class=\"swiper-slide js-year\" data-hash=\"" + year + "\">\n\t\t\t\t\t\n\t\t\t\t\t<div class=\"timeline-vertical__years--year\" data-index=\"" + index + "\">\n\n\t\t\t\t\t\t<div class=\"timeline-vertical__years--year__dot\">\n\n\t\t\t\t\t\t\t<div class=\"timeline-vertical__years--year__dot--inner\">\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"timeline-vertical__years--year__title\">\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t" + year + "\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>";
                htmlArticles += "<div class=\"swiper-slide\">";
                getArticles.map(function (section) {
                    var articles = section.articles;
                    if (!headingShown) {
                        htmlArticles += "<div class=\"timeline-vertical__content--heading\">\n\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"title title--module-title\">\n\n\t\t\t\t\t\t\t\t" + year + "\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>";
                        headingShown = true;
                    }
                    articles.map(function (article) {
                        htmlArticles += "<div class=\"timeline-vertical__content--year\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"timeline-vertical__content--year__content\">\n\t\t\t\n\t\t\t\t\t\t\t\t<div class=\"timeline-vertical__content--year__content--title\">\n\t\t\t\n\t\t\t\t\t\t\t\t\t" + article.title + "\n\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\n\t\t\t\t\t\t\t\t<div class=\"timeline-vertical__content--year__content--description\">\n\t\t\t\n\t\t\t\t\t\t\t\t\t" + article.description + "\n\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\n\t\t\t\t\t\t\t<div class=\"timeline-vertical__content--year__image\">\n\t\t\t\n\t\t\t\t\t\t\t\t<picture>\n\t\t\t\n\t\t\t\t\t\t\t\t\t<source srcset=\"" + article.imageDesktop + "\" media=\"(min-width: 1024px)\">\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<source srcset=\"" + article.imageTablet + "\" media=\"(min-width: 768px)\">\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<img class=\"responsive-image \" src=\"" + article.imageMobile + "\" srcset=\"" + article.imageMobile + "\" alt=\"\">\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</picture>\n\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\n\t\t\t\t\t\t</div>";
                    });
                });
                htmlArticles += "</div>";
            });
            this.filterYearSliderContainer.innerHTML = htmlYears;
            this.filterContentSliderContainer.innerHTML = htmlArticles;
            // content slider
            this.filterContentSlider = new Swiper(this.element.querySelector('.timeline-vertical__content--filter'), {
                slidesPerView: 'auto',
                direction: 'vertical',
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: true,
                mousewheel: {
                    invert: false,
                },
            });
            // year slider
            this.filterYearSlider = new Swiper(this.element.querySelector('.timeline-vertical__years--filter'), {
                slidesPerView: 20,
                direction: 'vertical',
                centeredSlides: true,
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: false,
            });
            // year slider OnChange event
            this.filterYearSlider.on('slideChange', function () {
                console.log('Slide Change');
                console.log(_this.filterYearSlider.realIndex);
                var yearsSliderContainer = _this.element.querySelector('.timeline-vertical__years--filter');
                if (_this.filterYearSlider.realIndex === 0) {
                    yearsSliderContainer.classList.remove('timeline-vertical__years--activated');
                }
                else {
                    yearsSliderContainer.classList.add('timeline-vertical__years--activated');
                }
            });
            this.filterYearSlides = Array.from(this.element.querySelectorAll('.timeline-vertical__years--filter .swiper-slide'));
            this.filterYearSlides.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var container = element.querySelector('.timeline-vertical__years--year');
                var getIndex = container.getAttribute('data-index');
                _this.filterContentSlider.slideTo(getIndex - 1);
                _this.filterYearSlider.slideTo(getIndex - 1);
            }); });
        }
        else {
            var selectedOption = parseInt(option);
            var lodashArray = json[selectedOption].items;
            var lodashArrayOrdered = _.orderBy(lodashArray, ['name'], ['desc']);
            lodashArrayOrdered.map(function (year) {
                var headingShown = false;
                var getArticles = year.articles;
                index = index + 1;
                htmlYears += "<div class=\"swiper-slide js-year\" data-hash=\"" + year.name + "\">\n\t\t\t\t\t\n\t\t\t\t\t<div class=\"timeline-vertical__years--year\" data-index=\"" + index + "\">\n\n\t\t\t\t\t\t<div class=\"timeline-vertical__years--year__dot\">\n\n\t\t\t\t\t\t\t<div class=\"timeline-vertical__years--year__dot--inner\">\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"timeline-vertical__years--year__title\">\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t" + year.name + "\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>";
                htmlArticles += "<div class=\"swiper-slide\">";
                getArticles.map(function (article) {
                    if (!headingShown) {
                        htmlArticles += "<div class=\"timeline-vertical__content--heading\">\n\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"title title--module-title\">\n\n\t\t\t\t\t\t\t\t" + year.name + "\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>";
                        headingShown = true;
                    }
                    htmlArticles += "<div class=\"timeline-vertical__content--year\">\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div class=\"timeline-vertical__content--year__content\">\n\t\t\n\t\t\t\t\t\t\t<div class=\"timeline-vertical__content--year__content--title\">\n\t\t\n\t\t\t\t\t\t\t\t" + article.title + "\n\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<div class=\"timeline-vertical__content--year__content--description\">\n\t\t\n\t\t\t\t\t\t\t\t" + article.description + "\n\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t<div class=\"timeline-vertical__content--year__image\">\n\t\t\n\t\t\t\t\t\t\t<picture>\n\t\t\t\n\t\t\t\t\t\t\t\t<source srcset=\"" + article.imageDesktop + "\" media=\"(min-width: 1024px)\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<source srcset=\"" + article.imageTablet + "\" media=\"(min-width: 768px)\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<img class=\"responsive-image \" src=\"" + article.imageMobile + "\" srcset=\"" + article.imageMobile + "\" alt=\"\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</picture>\n\t\t\n\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t</div>";
                });
                htmlArticles += "</div>";
            });
            this.filterYearSliderContainer.innerHTML = htmlYears;
            this.filterContentSliderContainer.innerHTML = htmlArticles;
            // content slider
            this.filterContentSlider = new Swiper(this.element.querySelector('.timeline-vertical__content--filter'), {
                slidesPerView: 'auto',
                direction: 'vertical',
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: true,
                mousewheel: {
                    invert: false,
                },
            });
            // year slider
            this.filterYearSlider = new Swiper(this.element.querySelector('.timeline-vertical__years--filter'), {
                slidesPerView: 20,
                direction: 'vertical',
                centeredSlides: true,
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: false,
            });
            // content slider OnChange event
            this.filterContentSlider.on('slideChange', function () {
                var yearsSliderContainer = _this.element.querySelector('.timeline-vertical__years--filter');
                if (_this.filterYearSlider.realIndex === 0) {
                    yearsSliderContainer.classList.remove('timeline-vertical__years--activated');
                }
                else {
                    yearsSliderContainer.classList.add('timeline-vertical__years--activated');
                }
                _this.filterYearSlider.slideTo(_this.filterContentSlider.realIndex);
            });
            // year slider OnChange event
            this.filterYearSlider.on('slideChange', function () {
                var yearsSliderContainer = _this.element.querySelector('.timeline-vertical__years--filter');
                if (_this.filterYearSlider.realIndex === 0) {
                    yearsSliderContainer.classList.remove('timeline-vertical__years--activated');
                }
                else {
                    yearsSliderContainer.classList.add('timeline-vertical__years--activated');
                }
                _this.filterContentSlider.slideTo(_this.filterYearSlider.realIndex);
            });
            this.filterYearSlides = Array.from(this.element.querySelectorAll('.timeline-vertical__years--filter .swiper-slide'));
            this.filterYearSlides.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var container = element.querySelector('.timeline-vertical__years--year');
                var getIndex = container.getAttribute('data-index');
                _this.filterContentSlider.slideTo(getIndex - 1);
                _this.filterYearSlider.slideTo(getIndex - 1);
            }); });
        }
    };
    return TimelineVertical;
}(Base));
export { TimelineVertical };



//////////////////
// WEBPACK FOOTER
// ./components/timeline-vertical/timeline-vertical.component.ts
// module id = 543
// module chunks = 0